var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 5.5,
    stroke: "#4D7AD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7556 32.5778L28.0682 26.8904C29.1699 25.5296 29.8332 23.8004 29.8332 21.9171C29.8332 17.5521 26.2815 14.0005 21.9166 14.0005C17.5516 14.0005 14 17.5521 14 21.9171C14 26.282 17.5516 29.8337 21.9166 29.8337C23.7999 29.8337 25.5291 29.1703 26.8899 28.0687L32.5773 33.7561C32.7398 33.9186 32.9531 34.0003 33.1665 34.0003C33.3798 34.0003 33.5932 33.9186 33.7557 33.7561C34.0815 33.4303 34.0815 32.9036 33.7556 32.5778ZM21.9166 28.167C18.47 28.167 15.6667 25.3637 15.6667 21.9171C15.6667 18.4704 18.47 15.6671 21.9166 15.6671C25.3632 15.6671 28.1665 18.4704 28.1665 21.9171C28.1665 25.3637 25.3632 28.167 21.9166 28.167Z",
    fill: "#4D7AD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_843"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b385e137bfae539ff1f0cb2f8ba5607b.svg";
export { ForwardRef as ReactComponent };